<template>
  <v-dialog
    v-model="dialog"
    :max-width="options.width"
    :style="{ zIndex: options.zIndex }"
    class="confirm-dialog"
    @keydown.esc="cancel"
    @after-leave="cancel"
  >
    <v-card class="pl-5 pr-5 pb-2">
      <v-toolbar dark :color="options.color" dense flat height="65">
        <v-toolbar-title class="pt-2">
          <slot name="title">
            {{ title ? $t(title) : title }}
          </slot>
        </v-toolbar-title>
        <v-toolbar-side-icon
            class="close-button"
            @click.native="cancel"
        >
          <v-icon>mdi-close</v-icon>
        </v-toolbar-side-icon>
      </v-toolbar>

      <slot name="content">
        <v-card-text
            v-show="!!message"
            class="text-black pl-0 pt-4 pb-4 pr-0"
            v-html="message"
        ></v-card-text>
      </slot>

      <v-card-actions class="flex-row pa-0 pt-1 pb-3">
        <v-btn
            v-if="!options.noconfirm"
            variant="outlined"
            @click.native="cancel"
            class="text-black me-auto action-button"
        >
          <slot name="cancelText">{{ $t('Нет') }}</slot>
        </v-btn>
        <v-btn
            color="primary"
            variant="elevated"
            @click.native="agree"
            class="action-button"
            :disabled="disabled"
        >
          <slot name="agreeText">{{ $t('Да') }}</slot>
        </v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ConfirmDialog',
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialog: false,
      resolve: null,
      reject: null,
      message: null,
      title: null,
      options: {
        color: 'white',
        width: 630,
        zIndex: 200,
        noconfirm: false,
      },
    };
  },
  emits: ['update:agree', 'update:cancel', 'update:open'],
  methods: {
    open(title, message, options) {
      this.dialog = true;
      this.$emit('update:open', true);
      this.title = title;
      this.message = message ? this.$t(message) : message;
      this.options = Object.assign(this.options, options);

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    agree() {
      this.$emit('update:agree');
      this.$emit('update:open', true);

      if (!this.resolve) {
        return;
      }

      this.resolve(true);
      this.dialog = false;
    },
    cancel() {
      this.$emit('update:cancel');
      this.$emit('update:open', false);

      if (!this.resolve) {
        return;
      }

      this.resolve(false);
      this.dialog = false;
    },
  },
};
</script>

<style scoped>
.confirm-dialog {
  color: rgba(var(--black-color));
  font-family: Abrade;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: normal;

  header {
    border-bottom: 1px solid #86868680;
  }

  .close-button:hover {
    cursor: pointer;
  }

  .v-toolbar-title {
    font-weight: 600;
    font-size: 16px;
    margin-inline-start: 0;
  }

  .action-button {
    font-family: Roboto;
    font-weight: 500;
    line-height: normal;
  }
}
</style>
